export const DASHBOARD_TOOLBAR_ICON_PX = 24 as const;
export const DASHBOARD_TOOLBAR_CONTROL_HEIGHT = 40 as const;
export const DASHBOARD_TOOLBAR_ARTWORK_PX = 40 as const;

export const DASHBOARD_SECTION_BAND_PY = 12 as const;
export const DASHBOARD_SECTION_BAND_PY_WIDE = 24 as const;

/** Gap between cards in dashboard-style grids (courses hub, lesson grids, search results). */
export const DASHBOARD_GRID_GAP = 16 as const;

export const dashboardSectionBandPadding = {
  py: DASHBOARD_SECTION_BAND_PY,
  $gtSm: { py: DASHBOARD_SECTION_BAND_PY_WIDE },
} as const;

export const dashboardToolbarArtworkButton = {
  circular: true,
  w: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
  h: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
  minWidth: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
  minHeight: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
  padding: 0,
  backgroundColor: 'transparent',
  borderWidth: 0,
} as const;

export const DASHBOARD_TOOLBAR_ICON_ACTIVE = '#0D0D0D';
export const DASHBOARD_TOOLBAR_ICON_INACTIVE = '#5C5854';

export function dashboardToolbarIconColor(active: boolean): string {
  return active ? DASHBOARD_TOOLBAR_ICON_ACTIVE : DASHBOARD_TOOLBAR_ICON_INACTIVE;
}

export const DASHBOARD_TOOLBAR_DROPDOWN_WIDTH_LESSONS = 135 as const;
export const DASHBOARD_TOOLBAR_DROPDOWN_WIDTH_SORT = 165 as const;
